import React, { Component } from 'react';

import './Guide.css';

import signup from './imgs/icon_signup.svg';
import shopping from './imgs/icon_shopping.svg';
import cashback from './imgs/icon_cashback.svg';
import arrow from './imgs/arrow.svg';

class Guide extends Component {
  render() {
    return (
      <div className="Guide">
        <h2>Start in a Flash</h2>
        <div className="Flow">
          <div className="Step">
            <img className="signup" src={signup} alt="SIGN UP"/>
            <div>
              <h5>SIGN UP</h5>
              <p>All you need is an email to sign up. Easy!</p>
            </div>
          </div>
          <img src={arrow} alt="Arrow"/>
          <div className="Step">
            <img src={shopping} alt="SHOPPING ONLINE"/>
            <div>
              <h5>SHOPPING ONLINE</h5>
              <p>Use our apps to explore the best available deals, seamlessly enjoy your shopping experience like never before.</p>
            </div>
          </div>
          <img src={arrow} alt="Arrow"/>
          <div className="Step">
            <img src={cashback} alt="GET CASHBACK" style={{margin: 6.5}}/>
            <div>
              <h5>CASHBACK!</h5>
              <p>Redeem gift cards and spend it in millions stores.</p>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default Guide;


// WEBPACK FOOTER //
// ./src/Containers/Home/components/Guide.js